import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpRequest } from "@angular/common/http";
import { Globals } from '../globals';
import { map, catchError } from "rxjs/operators";
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Injectable({
    providedIn: 'root'
})



export class ControlService {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals, private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');

    }


    // Method is used for Save user control screen Data
    SaveUserControlScreenData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'UserControlScreen' + '/TransUserControlScreenData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Save user control screen Data
    GetUserControlScreenData(EnergymeterMasterId: number, MeterID: string) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'UserControlScreen' + '/GetUserControlScreenData?EnergymeterMasterId=' + EnergymeterMasterId + '&MeterID=' + MeterID;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Save user control screen Data
    SaveWidgetPositionData(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'UserControlScreen' + '/SaveWidgetPositionData';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }

    // Method is used for Save user control screen Data
    DeleteWidgetbyUserDetailsId(ControlDetailsId: number) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'UserControlScreen' + '/DeleteWidgetbyUserDetailsId?ControlDetailsId=' + ControlDetailsId;
        return this.http.get(serviceCallURL)
            .pipe(map((resp: any) => resp),
                catchError(this._global.handleError)
            );
    }
}